export const normalizeSupplierTitle = title =>
  (title || '').trim().toLowerCase().replace(/\s+/g, ' ')

/** Dedupe OMS supplier search results by normalised title (first match wins). */
export const dedupeSuppliersByTitle = suppliers =>
  suppliers.filter((supplier, index, self) => {
    const key = normalizeSupplierTitle(supplier?.title)
    if (!key) return true
    return (
      index === self.findIndex(s => normalizeSupplierTitle(s?.title) === key)
    )
  })

const supplierSearchScore = (supplier, query) => {
  const title = normalizeSupplierTitle(supplier?.title)
  if (!title || !query) return 0
  if (title === query) return 100
  if (title.startsWith(query)) return 80
  if (title.split(' ').some(word => word.startsWith(query))) return 60
  if (title.includes(query)) return 40
  return 0
}

/** Filter and sort OMS suppliers by best match to the search query. */
export const rankSuppliersBySearchQuery = (suppliers, query) => {
  const normalizedQuery = normalizeSupplierTitle(query)
  if (!normalizedQuery) return []

  const deduped = dedupeSuppliersByTitle(suppliers)

  return deduped
    .map(supplier => ({
      supplier,
      score: supplierSearchScore(supplier, normalizedQuery),
    }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score
      return normalizeSupplierTitle(a.supplier?.title).localeCompare(
        normalizeSupplierTitle(b.supplier?.title),
      )
    })
    .map(({ supplier }) => supplier)
}
